import { render, staticRenderFns } from "./GuideScroller.vue?vue&type=template&id=6d609e87&scoped=true"
import script from "./GuideScroller.vue?vue&type=script&lang=ts"
export * from "./GuideScroller.vue?vue&type=script&lang=ts"
import style0 from "./GuideScroller.vue?vue&type=style&index=0&id=6d609e87&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d609e87",
  null
  
)

export default component.exports